import { RUN_REWARD_CONFIG, type RunRewardGoalConfig } from "../rewardLoopConfig";

export interface RunRewardInput {
  combo: number;
  perfectPickups: number;
  songAliveSeconds: number;
  distance: number;
  musicEnergy: number;
}

export interface RunRewardEvent {
  id: string;
  text: string;
  tone: RunRewardGoalConfig["tone"];
}

export class RunRewardSystem {
  private completed = new Set<string>();

  reset() {
    this.completed.clear();
  }

  update(input: RunRewardInput) {
    const events: RunRewardEvent[] = [];
    RUN_REWARD_CONFIG.goals.forEach((goal) => {
      if (this.completed.has(goal.id)) return;
      if (!this.isGoalComplete(goal, input)) return;
      this.completed.add(goal.id);
      events.push({ id: goal.id, text: goal.text, tone: goal.tone });
    });
    return events;
  }

  getCompletedLabels() {
    return RUN_REWARD_CONFIG.goals.filter((goal) => this.completed.has(goal.id)).map((goal) => goal.text);
  }

  private isGoalComplete(goal: RunRewardGoalConfig, input: RunRewardInput) {
    if (goal.kind === "combo") return input.combo >= goal.target;
    if (goal.kind === "perfect") return input.perfectPickups >= goal.target;
    if (goal.kind === "songAlive") return input.songAliveSeconds >= goal.target;
    if (goal.kind === "distance") return input.distance >= goal.target;
    if (goal.kind === "musicEnergy") return input.musicEnergy >= goal.target;
    return false;
  }
}
